import { createFileRoute } from "@tanstack/react-router";
import { MfeLoader } from "../../mfe/MfeLoader";
import { getUniversalOnboardingHostConfig } from "../../config/universalOnboardingHostConfig";
import { useHostNavigate } from "../../hooks/useHostNavigate";

export const Route = createFileRoute("/integrations/universalOnboarding/$")({
  component: UniversalOnboardingMfePage,
});

function UniversalOnboardingMfePage() {
  const onNavigate = useHostNavigate();
  return (
    <MfeLoader
      name="universal-onboarding"
      props={{ hostConfig: getUniversalOnboardingHostConfig(onNavigate) }}
    />
  );
}
